<template>
  <div>
    <vx-card class="w-full p-3">
      <template #no-body>
        <div class="flex flex-col">
          <div class="w-full flex flex-col md:flex-row ">
            <div class="flex items-center flex-1 mb-2 md:m-0">
              <img :src="iconFile" width="20px" alt="File" srcset="" />
              <div class="mx-4">
                <p class="text-md">{{ item.nama | removeExtensions }}</p>
                <p class="text-sm text-grey">
                  {{ item.besar_dokumen }}
                </p>
              </div>
            </div>
            <!-- Action -->
            <div class="flex items-center justify-end ">
              <slot name="action"></slot>
            </div>
          </div>
        </div>
      </template> </vx-card
    ><br />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    forceTypeFile: {
      type: String,
      default: ""
    }
  },
  filters: {
    removeExtensions(filename) {
      const isHaveExtension = filename.split(".").length > 1;
      // console.log(isHaveExtension);

      if (isHaveExtension)
        return filename
          .split(".")
          .slice(0, -1)
          .join(".");
      else return filename;
    }
  },
  data() {
    return {
      iconProperties: [
        {
          icon: "/images/file-icons/doc.png",
          iconTypes: ["doc", "docx"]
        },
        {
          icon: "/images/file-icons/xls.png",
          iconTypes: ["xls", "xlsx"]
        },
        {
          icon: "/images/file-icons/jpg.png",
          iconTypes: ["jpg", "png", "jpeg"]
        },
        {
          icon: "/images/file-icons/pdf.png",
          iconTypes: ["pdf"]
        },
        {
          icon: "/images/file-icons/ppt.png",
          iconTypes: ["ppt"]
        },
        {
          icon: "/images/file-icons/ppt.png",
          iconTypes: ["pptx"]
        }
      ]
    };
  },
  methods: {
    checkIconType() {
      const typeFile =
        this.forceTypeFile !== ""
          ? this.forceTypeFile
          : this.item.jenis_dokumen;

      return this.iconProperties.filter(({ iconTypes }) => {
        return iconTypes.includes(typeFile);
      });
    }
  },
  computed: {
    iconFile() {
      const iconSelected = this.checkIconType();
      return iconSelected[0].icon;
    }
  }
};
</script>
